import { useCallback, useState } from 'react';

type UseAddContacsFromGroupParams = {
	onContactsGroupsSelected: ( emails: string[] ) => void;
};

const useAddContactsFromGroup = ( { onContactsGroupsSelected }: UseAddContacsFromGroupParams ) => {
	const [ shouldShowContactsGroupsModal, setShouldShowContactsGroupsModal ] = useState( false );

	const onAddGroupClicked = useCallback( () => setShouldShowContactsGroupsModal( true ), [] );
	const onCloseContactsGroupsModal = useCallback( () => setShouldShowContactsGroupsModal( false ), [] );
	const onConfirmContactsGroupsModal = useCallback( ( emailsFromGroups: string[] ) => {
		onContactsGroupsSelected( emailsFromGroups );
		onCloseContactsGroupsModal();
	}, [ onContactsGroupsSelected, onCloseContactsGroupsModal ] );

	return {
		shouldShowContactsGroupsModal,
		onAddGroupClicked,
		onCloseContactsGroupsModal,
		onConfirmContactsGroupsModal
	};
};

export default useAddContactsFromGroup;
